export default __webpack_public_path__ + "madfit-devices@2x.215cb03a.png";